import getDetailsContent from '../../../utils/getDetailsContent';
import Lightbox from '../../../elements/Lightbox';
import scrollElementTo from '~/utils/animation/scrollElementTo';
import {trigger} from '~/app/utils/trigger';
import {spaceNumber} from '~/app/utils/spaceNumber';

export const initCalculator = ( apartmentCard ) => {
	const toMortgageCalculatorButton = apartmentCard.querySelectorAll( 'ul.price-select li' );
	const mortgageCalculator = apartmentCard.querySelector( 'section.mortgage-calculator' );
	const mortgageForm = mortgageCalculator.querySelector( 'form' );
	const bankList = mortgageCalculator.querySelector( 'div.select.banks' );
	const programList = mortgageCalculator.querySelector( 'div.select.program-types' );
	const lightboxContent = getDetailsContent( apartmentCard.querySelector( 'li.reserve details' ) );
	const lightbox = Lightbox.instance;
	const reserveForm = apartmentCard.querySelector( 'form[name="choose"]' );
	let isBankChosen = false;
	let isMortgageTypeChosen = false;
	let isPromoShown = false;

	if ( !toMortgageCalculatorButton.length || !mortgageCalculator )
	{
		return;
	}

	Array.from( toMortgageCalculatorButton ).forEach( ( it ) => {
		it.addEventListener(
			'click',
			() =>
			{
				scrollElementTo( window, mortgageCalculator.offsetTop, 500 );
			},
		);
	} );

	const installPaymentInput = mortgageForm.querySelector( '[name="install-payment"]' );
	const timeInput = mortgageForm.querySelector( 'input[name="payment-time"]' );

	const reserveFormUpdate = ( input ) => {
		if ( reserveForm.querySelector( 'input[name="install_payment"]' ) )
		{
			reserveForm.querySelector( 'input[name="install_payment"]' ).remove();
			reserveForm.querySelector( 'input[name="term"]' ).remove();
			reserveForm.querySelector( 'input[name="bank"]' ).remove();
			reserveForm.querySelector( 'input[name="program_id"]' ).remove();
			reserveForm.querySelector( 'input[name="program"]' ).remove();
		}

		if ( input )
		{
			const programTable = input.closest( 'div.bank-card' ).querySelector( 'table.selected-program' );

			programTable.innerHTML = `<tr><th></th>${input.dataset.base ? `<th>Базовый платёж </th>` : ``}<th>${input.dataset.base ? input.dataset.baseTitle : `Ежемесячный платёж`}</th><th>Ставка</th><th>Первый взнос</th><th>Срок</th></tr><tr><td class="title">${input.dataset.base ? `* ` : ``}${input.dataset.title}</td><td class="payment" data-label="${input.dataset.base ? input.dataset.baseTitle : `Ежемесячный платёж`}"><strong>${input.dataset.monthPayment}</strong>&nbsp;₽${input.dataset.base ? `/мес.` : ``}</td>${input.dataset.base ? `<td class="base" data-label="Базовый платёж">${input.dataset.base}&nbsp;₽/мес.</td>` : ``}<td class="mobile" data-label="Ставка">${input.dataset.rate}</td><td class="mobile" data-label="Первый взнос">${input.dataset.minPayment}</td><td class="mobile" data-label="Срок">${input.dataset.maxTerm}</td></tr>`;
			
			reserveForm.insertAdjacentHTML( 'afterbegin', `<input type="hidden" name="install_payment" value="${installPaymentInput.value}" /><input type="hidden" name="term" value="${timeInput.value}" /><input type="hidden" name="bank" value="${input.dataset.bank}" /><input type="hidden" name="program_id" value="${input.dataset.id}" /><input type="hidden" name="program" value="${input.dataset.title}" />` );
		}
	};

	const calculateMortgage = () => {
		const term = parseInt( timeInput.value );
		const price = parseInt( document.querySelector( 'ul.prices strong[data-cost]' ).dataset.cost );
		const firstPayment = ( parseInt( installPaymentInput.value.replace( /\s/g, '' ) ) / price * 100 ).toFixed( 2 );
		let types = '';

		mortgageForm.querySelector( '[data-sum]' ).dataset.sum = `${spaceNumber( price - parseInt( installPaymentInput.value.replace( /\s/g, '' ) ) )} ₽`;

		Array.from( mortgageForm.querySelectorAll( 'input[name="mortgage_type"]:checked' ) ).forEach( ( it ) => {
			if ( it.id === 'mortgage_type_developer_special' )
			{
				return;
			}
			
			if ( types )
			{
				types += ',';
			}
			
			types += it.value;
		} );
		
		fetch( location.pathname, {
			'method': 'POST',
			'headers': {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			},
			'body': `mortgage=1&price=${price}&term=${term}&first-payment=${firstPayment}${types ? `&types=${types}`: ''}${isPromoShown ? '&promo=1' : ''}`,
		} )
			.then( ( response ) => response.json() )
			.then( ( msg ) => {
				const openedBanks = [];
				const currentBanks = [];
				let currentProgram;

				Array.from( mortgageCalculator.querySelectorAll( 'input[name*="proram_hide"]:checked' ) ).forEach( ( it ) => {
					openedBanks.push( it.id );
				} );
				
				if ( isBankChosen )
				{
					Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]:checked' ) ).forEach( ( it ) => {
						currentBanks.push( it.dataset.bank );
					} );
				}
				
				if ( mortgageCalculator.querySelector( 'input[name="program"]:checked' ) )
				{
					currentProgram = mortgageCalculator.querySelector( 'input[name="program"]:checked' ).id;
				}
				
				Array.from( bankList.querySelectorAll( 'li[data-bank]' ) ).forEach( ( it ) => {
					if ( msg['banks_new'].programs.items[it.dataset.bank] )
					{
						it.style.display = '';
					}
					else
					{
						it.style.display = 'none';
					}
				} );
				
				Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]' ) ).forEach( ( it ) => {
					it.nextElementSibling.remove();
					it.remove();
				} );

				if ( mortgageCalculator.querySelector( 'div.empty' ) )
				{
					mortgageCalculator.querySelector( 'div.empty' ).remove();
				}

				mortgageCalculator.insertAdjacentHTML( 'beforeend', msg.rendered );

				Array.from( openedBanks ).forEach( ( it ) => {
					mortgageCalculator.querySelector( `input#${it}` ).checked = true;
				} );
				
				if ( isBankChosen )
				{
					Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]:checked' ) ).forEach( ( it ) => {
						it.checked = false;
					} );

					Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]' ) ).forEach( ( it ) => {
						if ( currentBanks.indexOf( it.dataset.bank ) > -1 )
						{
							it.checked = true;
						}
					} );
				}

				currentProgram = currentProgram ? currentProgram : mortgageCalculator.querySelector( 'input[id*="program"]' ).id;

				const currentProgramInput = mortgageCalculator.querySelector( `input#${currentProgram}` ) || mortgageCalculator.querySelector( 'input[id*="program"]' );

				if ( currentProgramInput )
				{
					currentProgramInput.checked = true;
					reserveFormUpdate( currentProgramInput );
				}
			} );
	};

	const showOffers = ( evt ) => {
		const programSelect = mortgageCalculator.querySelector( 'div.select.program-types' );
		const turnOn = evt.target.classList.contains( 'promo-programs' ) && !mortgageCalculator.querySelector( 'input#mortgage_type_developer_special' ).checked || evt.target.id === 'mortgage_type_developer_special' && mortgageCalculator.querySelector( 'input#mortgage_type_developer_special' ).checked || evt.target.id === 'price_option_special';

		Array.from( mortgageCalculator.querySelectorAll( 'input[name="mortgage_type"]' ) ).forEach( ( it ) => {
			it.checked = false;
		} );

		if ( turnOn )
		{
			apartmentCard.querySelector( 'input#price_option_special' ).checked = true;
			mortgageForm.classList.add( 'promo' );
			programSelect.querySelector( 'span[data-empty]' ).innerHTML = programSelect.querySelector( 'label[for="mortgage_type_developer_special"]' ).innerHTML;
			mortgageCalculator.querySelector( 'input#mortgage_type_developer_special' ).checked = true;
			isPromoShown = true;
		}
		else
		{
			apartmentCard.querySelector( 'input#price_option_mortgage' ).checked = true;
			mortgageForm.classList.remove( 'promo' );
			programSelect.querySelector( 'span[data-empty]' ).innerHTML = '';
			mortgageCalculator.querySelector( 'input#mortgage_type_developer_special' ).checked = false;
			isPromoShown = false;
		}

		calculateMortgage();
	};

	calculateMortgage();

	apartmentCard.addEventListener( 'change', ( evt ) => {
		if ( evt.target.name !== 'price_option' )
		{
			return;
		}

		const oldPrice = apartmentCard.querySelector( 'input[name="price_option"]:not( :checked )' ).dataset.price;
		const isMortgage = evt.target.dataset.name  === 'Ипотека';

		reserveForm.dataset.criteo = reserveForm.dataset.criteo.replace( oldPrice, evt.target.dataset.price );
		reserveForm.dataset.bitrix = reserveForm.dataset.bitrix.replace( oldPrice, evt.target.dataset.price );
		reserveForm.querySelector( 'input[name="price_option_chosen"]' ).value = evt.target.dataset.name;
		reserveFormUpdate( mortgageCalculator.querySelector( 'input[name="program"]:checked' ) );
	} );

	const inputs = Array.from( mortgageForm.querySelectorAll( 'input' ) );

	if ( !inputs.length )
	{
		return;
	}

	for ( const input of inputs )
	{
		input.addEventListener( 'change', ( evt ) => {
			if ( input.classList.contains( 'front-only' ) )
			{
				return;
			}

			if ( input.id === 'mortgage_type_developer_special' )
			{
				showOffers( evt );

				return;
			}

			if ( input.name === 'mortgage_type' )
			{
				mortgageCalculator.querySelector( 'div.select.program-types' ).classList.remove( 'promo' );
				mortgageCalculator.querySelector( 'input#mortgage_type_developer_special' ).checked = false;
			}

			calculateMortgage();
		} );
	}

	mortgageCalculator.addEventListener( 'change', ( evt ) => {
		let selectedBankText = '';
		let selectedTypeText = '';
		
		if ( evt.target.name === 'bank' )
		{
			const requestedBankID = evt.target.id;

			if ( isBankChosen )
			{
				if ( mortgageCalculator.querySelectorAll( 'input[name="bank"]:not( :checked )' ).length && mortgageCalculator.querySelectorAll( 'input[name="bank"]:checked' ).length )
				{
					if ( evt.target.checked )
					{
						mortgageCalculator.querySelector( `[for="${requestedBankID}"]` ).classList.add( 'selected' );
					}
					else
					{
						mortgageCalculator.querySelector( `[for="${requestedBankID}"]` ).classList.remove( 'selected' );
					}

					Array.from( mortgageCalculator.querySelectorAll( 'div.select.banks ul label.selected' ) ).forEach( ( it ) => {
						if ( selectedBankText )
						{
							selectedBankText += ', ';
						}
						
						selectedBankText += it.innerHTML;
					} );
				}
				else
				{
					Array.from( mortgageCalculator.querySelectorAll( 'div.select.banks ul label' ) ).forEach( ( it ) => {
						it.classList.remove( 'selected' );
					} );

					Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]' ) ).forEach( ( it ) => {
						it.checked = true;
					} );

					selectedBankText = '';
					isBankChosen = false;
				}
			}
			else
			{
				isBankChosen = true;
				mortgageCalculator.querySelector( `[for="${requestedBankID}"]` ).classList.add( 'selected' );

				Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]' ) ).forEach( ( it ) => {
					it.checked = false;
				} );

				evt.target.checked = true;
				selectedBankText = mortgageCalculator.querySelector( `[for="${requestedBankID}"]` ).innerHTML;
			}

			mortgageCalculator.querySelector( 'div.select.banks span[data-empty]' ).innerHTML = selectedBankText;
		}

		if ( evt.target.name === 'program' )
		{
			reserveFormUpdate( evt.target );
		}

		if ( evt.target.name === 'mortgage_type' )
		{
			const requestedTypeID = evt.target.id;

			if ( isMortgageTypeChosen )
			{
				if ( mortgageCalculator.querySelectorAll( 'input[name="mortgage_type"]:not( :checked )' ).length && mortgageCalculator.querySelectorAll( 'input[name="mortgage_type"]:checked' ).length )
				{
					Array.from( mortgageCalculator.querySelectorAll( 'div.select.program-types ul input:checked' ) ).forEach( ( it ) => {
						if ( selectedTypeText )
						{
							selectedTypeText += ', ';
						}
						
						selectedTypeText += mortgageCalculator.querySelector( `[for="${it.id}"]` ).innerHTML;
					} );
				}
				else
				{
					selectedTypeText = '';
					isMortgageTypeChosen = false;

					Array.from( mortgageCalculator.querySelectorAll( 'input[name="mortgage_type"]' ) ).forEach( ( it ) => {
						it.checked = false;
					} );
				}
			}
			else
			{
				isMortgageTypeChosen = true;
				selectedTypeText = mortgageCalculator.querySelector( `[for="${requestedTypeID}"]` ).innerHTML;
			}

			mortgageCalculator.querySelector( 'div.select.program-types span[data-empty]' ).innerHTML = selectedTypeText;
		}
	} );

	mortgageCalculator.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.closest( 'details' ) )
		{
			return;
		}

		evt.preventDefault();
		apartmentCard.querySelector( 'input#price_option_mortgage' ).checked = true;
		trigger( apartmentCard.querySelector( 'input#price_option_mortgage' ), 'change' );
		lightbox.open( lightboxContent );
	} );

	mortgageCalculator.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.closest( 'div.select' ) || !evt.target.classList.contains( 'all' ) )
		{
			return;
		}

		const select = evt.target.closest( 'div.select' );

		if ( select.classList.contains( 'banks' ) )
		{
			isBankChosen = false;

			Array.from( select.querySelectorAll( 'ul label.selected' ) ).forEach( ( it ) => {
				it.classList.remove( 'selected' );
			} );

			Array.from( mortgageCalculator.querySelectorAll( 'input[name="bank"]' ) ).forEach( ( it ) => {
				it.checked = true;
			} );
		}
		else
		{
			isMortgageTypeChosen = false;

			Array.from( mortgageCalculator.querySelectorAll( 'input[name="mortgage_type"]' ) ).forEach( ( it ) => {
				it.checked = false;
			} );

			trigger( mortgageCalculator.querySelector( 'input[name="mortgage_type"]' ), 'change' );
		}

		select.querySelector( 'span[data-empty]' ).innerHTML = '';
		select.querySelector( 'input.front-only' ).checked = false;
	} );

	Array.from( apartmentCard.querySelectorAll( 'input[name="price_option"]' ) ).forEach( ( it ) => {
		it.addEventListener( 'change', showOffers );
	} );

	mortgageCalculator.querySelector( 'div.select button.promo-programs' ).addEventListener( 'click', showOffers );
};


//////////////////
// WEBPACK FOOTER
// ./app/Routes/Choose/Card/initCalculator.js
// module id = x8KX
// module chunks = 11